// src/components/layout/TopBar.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Navigation from '../navigation/Navigation';
import MobileMenu from './MobileMenu';

const TopBar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const openMobileMenu = () => {
    setMobileMenuOpen(true);
  };
  
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="bg-primary sticky top-0 z-40 shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo with the three vertical lines */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center">
                {/* Three vertical lines logo */}
                <div className="mr-2 flex space-x-1">
                  <div className="h-6 w-1.5 rounded-full bg-accent"></div>
                  <div className="h-8 w-1.5 rounded-full bg-accent"></div>
                  <div className="h-6 w-1.5 rounded-full bg-accent"></div>
                </div>
                {/* Brand name */}
                <h1 className="text-2xl font-bold">
                  <span className="text-white">AMV</span>
                  <span className="text-accent"> LAW</span>
                </h1>
              </Link>
            </div>
          </div>
          
          {/* Desktop Navigation */}
          <Navigation />
          
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button 
              type="button" 
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-primary-light"
              onClick={openMobileMenu}
            >
              <span className="sr-only">Open menu</span>
              <Menu className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu (completely separate from desktop navigation) */}
      <MobileMenu isOpen={mobileMenuOpen} onClose={closeMobileMenu} />
    </header>
  );
};

export default TopBar;